"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.INVOICING_ENDPOINT = {
    getIndex: '/invoicing/{{version}}/users/{{userUuid}}/invoices',
    getInvoice: '/invoicing/{{version}}/invoices/{{invoiceUuid}}',
    putPayInvoice: '/invoicing/{{version}}/invoices/{{invoiceUuid}}/pay',
};
